import { render, staticRenderFns } from "./QuestionPopup.vue?vue&type=template&id=44fee601&"
import script from "./QuestionPopup.vue?vue&type=script&lang=js&"
export * from "./QuestionPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports